<template>
  <v-container>
    <v-layout row wrap>
      <a-side-box />

      <v-flex md6>
        <benefits
          icon="event"
          title="Nadchodzące wydarzenia"
          :events="true"
          :limit="2"
          :showMore="true"
          :inrow="2"
          :more-target="{name:'benefits_events'}"
        >
          <template slot="more">Więcej wydarzeń</template>
        </benefits>
      </v-flex>
      <v-divider></v-divider>

      <v-flex md3>
        <history icon="history" title="Historia" :show-more="true">
          <template slot="more">Historia</template>
        </history>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import store from '@/store/store';
import Benefits from '@/components/benefits/Benefits';
import ASideBox from '@/components/ASideBox';
import History from '@/components/history/History';
import { SessionStorage } from '@/enums/sessionStorage.enum';

// @vuese
// Strona główna po zalogowaniu
// @group Views
export default {
  components: { ASideBox, Benefits, History },
  mixins: [],
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    })
  },
  async beforeRouteEnter(to, from, next) {
    store.commit(
      'profile/setId',
      sessionStorage.getItem(SessionStorage.USER_ID)
    );
    Promise.all([
      store.dispatch('benefits/userBenefits', {
        event: true,
        count: 2,
        order: 'start',
        desc: true
      }),
      store.dispatch('profile/get'),
      store.dispatch('benefitsUsage/list', {
        profileId: parseInt(sessionStorage.getItem(SessionStorage.PROFILE_ID)),
        count: 4,
        order: 'created',
        desc: true
      })
    ]).then(() => next());
  }
};
</script>
<style>
.title {
  line-height: normal !important;
  font-weight: 300 !important;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
h5 {
  font-size: 2.2rem;
  font-weight: 300;
}
.history li {
  background-color: white;
  margin-bottom: 1rem;
  padding: 1rem;
  list-style: none;
}
.history span {
  display: block;
}
.history .day {
  font-weight: 300;
  font-size: 1.3rem;
  text-align: right;
  color: teal;
}

.history .partner {
  font-style: normal;
  display: block;
  font-size: 0.85rem;
  line-height: normal !important;
  margin-top: 1rem;
  color: teal;
}
</style>